import React from 'react'
import connect from 'react-redux/es/connect/connect'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Typography from '@material-ui/core/Typography'
import moment from 'moment-timezone'
import { seconds } from '@relativity/js-util'

import {
  changeDialogOpenState,
  startAllWorkerJobsPoll,
  stopAllWorkerJobsPoll,
} from 'redux/admin/Actions'

import {
  DIALOG_NAME_RUNNING_WORKER_JOBS,
  URL_API_ADMIN_ROOT,
} from 'redux/constants'
import {getRunningWorkerJobs} from 'common/model/WorkerJob'

import DialogTitle from 'common/components/dialog/DialogTitle'
import DialogContent from 'common/components/dialog/DialogContent'
import DialogActions from 'common/components/dialog/DialogActions'

import styles from './style'

const pad2 = (num) => {
  return (num + '').padStart(2, '0')
}

const runningFor = (worker) => {
  const totalSeconds = seconds() - worker.uLastRunStart
  return `${Math.floor(totalSeconds / 60)}:${pad2(totalSeconds % 60)}`
}

class RunningWorkerJobsDialog extends React.Component {

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }

  componentDidUpdate(prevProps) {
    if(!prevProps.isOpen && this.props.isOpen) {
      this.props.startAllWorkerJobsPoll({msPolling:500})
    }
    if(prevProps.isOpen && !this.props.isOpen) {
      this.props.stopAllWorkerJobsPoll()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    if(this.props.isOpen) {
      this.props.stopAllWorkerJobsPoll()
      // dialog is going away without an explicit Cancel click (e.g. navigated away); let the saga know so it can resume the jobs
      this.props.changeDialogOpenState({dialogName: DIALOG_NAME_RUNNING_WORKER_JOBS, isOpen: false})
    }
  }

  // last-resort cleanup for an actual tab/browser close, where the saga never gets a chance to run
  handleBeforeUnload = () => {
    if(this.props.isOpen && navigator.sendBeacon) {
      navigator.sendBeacon(`${URL_API_ADMIN_ROOT}/worker_job/resume_all`)
    }
  }

  handleCancel = () => {
    this.props.changeDialogOpenState({dialogName: DIALOG_NAME_RUNNING_WORKER_JOBS, isOpen: false})
    if(this.props.onCancel) this.props.onCancel()
  }

  render() {
    const {classes, isOpen, workerJobs} = this.props

    if(!isOpen) return null

    const runningWorkerJobs = getRunningWorkerJobs(workerJobs)

    return (
      <Dialog
        onClose={this.handleCancel}
        aria-labelledby="running-worker-jobs-dialog-title"
        open={isOpen}
        PaperProps={{
          style: { minWidth: '800px' }
        }}
      >
        <DialogTitle id="running-worker-jobs-dialog-title" onClose={this.handleCancel}>
          Stopping Worker Jobs
        </DialogTitle>
        <DialogContent className={classes.dialogContentRoot}>
          <Typography variant="body1" style={{marginTop:10, marginBottom:10}}>
            The jobs below are currently running. Waiting for all worker jobs to stop before continuing.
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Job</TableCell>
                <TableCell>Started</TableCell>
                <TableCell>Running For</TableCell>
                <TableCell>Summary</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {runningWorkerJobs.length === 0 ?
                <TableRow><TableCell colSpan={4}><Typography variant="h6">No worker jobs are currently running.</Typography></TableCell></TableRow>
              : null}
              {runningWorkerJobs.map(worker => (
                <TableRow key={worker.id}>
                  <TableCell>{worker.displayName}</TableCell>
                  <TableCell style={{whiteSpace:'nowrap'}}>{moment.unix(worker.uLastRunStart).format('ddd HH:mm:ss')}</TableCell>
                  <TableCell style={{whiteSpace:'nowrap'}}>{runningFor(worker)}</TableCell>
                  <TableCell>{worker.runStatusSummary}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions style={{marginTop:10}}>
          <Button onClick={this.handleCancel} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    isOpen: !!state.admin.dialogs[DIALOG_NAME_RUNNING_WORKER_JOBS],
    workerJobs: state.admin.workerJobs,
  }
}

const mapDispatchToProps = {
  changeDialogOpenState,
  startAllWorkerJobsPoll,
  stopAllWorkerJobsPoll,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(RunningWorkerJobsDialog))
